import ScrollReveal from '../animations/ScrollReveal';
import LazyVideo from './LazyVideo';

class Blog extends ScrollReveal {
  constructor(wWidth) {
    super();
    this.wWidth = wWidth;
    this.$container = $('.blog-grid');
    this.$inner = this.$container.find('.blog-grid__inner');
    this.$posts = this.$container.find('.blog-grid__post');
    this.$loadMore = this.$container.find('.blog-grid__load-more');
    this.lazyVideo = new LazyVideo();

    if (!this.$container.length) return;
    this.init();
  }

  init() {
    this.$container.delegate(
      '.load-more',
      'click',
      this.handleLoadMore.bind(this)
    );

    theme.cur_page = +theme.cur_page;
    theme.max_page = +theme.max_page;
    this.updateLoadMore();

    setTimeout(() => {
      this.alignTitles();
    }, 50);
  }

  handleLoadMore(e) {
    e.preventDefault();

    const $cur = $(e.currentTarget);
    const href = $cur.attr('href');

    this.loadMoreData = {
      action: 'load_more',
      query: theme.posts,
      page: theme.cur_page,
    };

    $.ajax({
      url: theme.ajax,
      data: this.loadMoreData,
      type: 'POST',
      beforeSend: () => {
        this.$loadMore.addClass('is-loading');
      },
      success: (response) => {
        if (!response) {
          this.$loadMore.addClass('is-hidden');
          return;
        }

        // append new posts
        const $newPosts = $(response).filter('.blog-grid__post');
        this.$loadMore.before($newPosts);
        theme.cur_page += 1;

        this.updateLoadMore();

        // update url
        window.history.pushState(null, null, href);

        // update button url but increase page number
        const newHref = href.replace(/page\/\d+/, `page/${theme.cur_page + 1}`);
        this.$loadMore.find('.load-more').attr('href', newHref);

        // align titles
        this.alignTitles();

        // reveal new posts
        this.revealTargets($newPosts);

        // find lazy videos
        const $videos = $newPosts.find('video');
        this.lazyVideo.revealTargets($videos);
      },
    });
  }

  updateLoadMore() {
    // hide button if last page or enable again
    if (theme.cur_page >= theme.max_page) {
      this.$loadMore.addClass('is-hidden');
    } else {
      this.$loadMore.removeClass('is-loading');
    }
  }

  alignTitles() {
    this.$posts = this.$container.find('.blog-grid__post');
    this.$titles = this.$posts.find('.blog-grid-post__title');

    // reset all titles heights
    this.$titles.css('min-height', 0);

    // no need on mobile
    if (this.wWidth < 768) return;

    // group posts by rows
    const rows = [];
    const perRow = this.wWidth > 1023 ? 3 : 2;
    let row = [];

    this.$posts.each((i, el) => {
      row.push(el);
      if (row.length === perRow) {
        rows.push(row);
        row = [];
      }
    });

    // align titles in each row
    rows.forEach((r) => {
      const $titles = $(r).find('.blog-grid-post__title');
      const $titlesHeight = $titles.map((i, el) => $(el).height());
      const maxHeight = Math.max.apply(null, [...$titlesHeight]);

      $titles.css('min-height', maxHeight);
    });
  }

  onResize(wWidth) {
    this.wWidth = wWidth;
    this.alignTitles();
  }
}

export default Blog;
